const vaccineGuideElement = document.querySelector('.bg-vaccine-guide');

const vaccinationsUrl = vaccineGuideElement
    ?.dataset
    .vaccinationsUrl;

const vaccinePassReaderUrl = vaccineGuideElement
    ?.dataset
    .vaccinePassReaderUrl;

const aiClientHeaderValue = 'marahs-muemmler-v1';
const maxAiUploadFiles = 4;
const maxAiUploadBytesPerFile = 6 * 1024 * 1024;
const maxAiUploadTotalBytes = 18 * 1024 * 1024;

const allowedAiUploadTypes = [
    'image/jpeg',
    'image/png',
    'image/webp'
];

let vaccinationsCache = null;

function showAlert(message, type = 'danger', scrollToAlert = true) {
    const alertElement = document.querySelector('.bg-global-alert');

    if (!alertElement) {
        console.error(message);
        return;
    }

    alertElement.className = `bg-global-alert bg-global-alert--${type}`;
    alertElement.innerHTML = message;
    alertElement.style.display = 'block';

    if (scrollToAlert) {
        alertElement.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });
    }
}

function hideAlert() {
    const alertElement = document.querySelector('.bg-global-alert');

    if (!alertElement) {
        return;
    }

    alertElement.style.display = 'none';
    alertElement.innerHTML = '';
}

function showAiUploadStatus(message, type = 'info') {
    const statusElement = document.querySelector('.bg-ai-upload__status');

    if (!statusElement) {
        return;
    }

    statusElement.className = `bg-ai-upload__status bg-ai-upload__status--${type}`;
    statusElement.textContent = message;
    statusElement.style.display = 'block';
}

function hideAiUploadStatus() {
    const statusElement = document.querySelector('.bg-ai-upload__status');

    if (!statusElement) {
        return;
    }

    statusElement.textContent = '';
    statusElement.style.display = 'none';
}

function setAiUploadLoading(isLoading) {
    const button = document.querySelector('.bg-ai-upload__button');

    if (!button) {
        return;
    }

    button.disabled = isLoading;
    button.textContent = isLoading
        ? 'Impfpass wird ausgelesen...'
        : 'Impfpass auslesen';
}

function openVaccinationHelpModal() {
    const modalElement = document.querySelector('#vaccinationHelpModal');

    if (!modalElement) {
        return;
    }

    modalElement.classList.add('is-open');
    modalElement.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
}

function closeVaccinationHelpModal() {
    const modalElement = document.querySelector('#vaccinationHelpModal');

    if (!modalElement) {
        return;
    }

    modalElement.classList.remove('is-open');
    modalElement.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
}

function openDisclaimerModal() {
    const modalElement = document.querySelector('#disclaimerModal');

    if (!modalElement) {
        return;
    }

    modalElement.classList.add('is-open');
    modalElement.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
}

function closeDisclaimerModal() {
    const modalElement = document.querySelector('#disclaimerModal');

    if (!modalElement) {
        return;
    }

    modalElement.classList.remove('is-open');
    modalElement.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
}

function disclaimerAccepted() {
    const checkbox = document.querySelector('#disclaimerAccepted');

    return Boolean(checkbox?.checked);
}

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        closeVaccinationHelpModal();
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const fileInput = document.querySelector('#vaccinePassImage');

    if (fileInput) {
        fileInput.addEventListener('change', () => {
            const selectedFilesElement = document.querySelector('.bg-ai-upload__selected-files');
            const dropzoneElement = document.querySelector('.bg-ai-upload__dropzone');

            if (!selectedFilesElement || !dropzoneElement) {
                return;
            }

            if (fileInput.files.length === 0) {
                selectedFilesElement.textContent = 'Noch keine Dateien ausgewählt';
                dropzoneElement.classList.remove('has-files');
                return;
            }

            selectedFilesElement.textContent = `${fileInput.files.length} Bild(er) ausgewählt`;
            dropzoneElement.classList.add('has-files');
        });
    }

    ensureDefaultVaccinationRow();
});

function parseDateFromInput(value) {
    if (!value) {
        return null;
    }

    const parts = value.split('-');

    if (parts.length !== 3) {
        return null;
    }

    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1;
    const day = parseInt(parts[2], 10);

    return new Date(year, month, day);
}

function isValidIsoDate(value) {
    if (!value || typeof value !== 'string') {
        return false;
    }

    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return false;
    }

    const date = parseDateFromInput(value);

    if (!date || Number.isNaN(date.getTime())) {
        return false;
    }

    const [year, month, day] = value.split('-').map((part) => {
        return parseInt(part, 10);
    });

    const today = new Date();
    today.setHours(23, 59, 59, 999);

    if (date > today) {
        return false;
    }

    return date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day;
}

function addDays(date, days) {
    const result = new Date(date);

    result.setDate(result.getDate() + days);

    return result;
}

function subtractDays(date, days) {
    const result = new Date(date);

    result.setDate(result.getDate() - days);

    return result;
}

function sortVaccinationsByName(vaccinations) {
    return [...vaccinations].sort((vaccinationA, vaccinationB) => {
        return vaccinationA.name.localeCompare(
            vaccinationB.name,
            'de',
            {
                sensitivity: 'base'
            }
        );
    });
}

async function loadVacs(forceReload = false) {
    try {
        if (vaccinationsCache && !forceReload) {
            return vaccinationsCache;
        }

        if (!vaccinationsUrl) {
            throw new Error('vaccinations.json URL fehlt.');
        }

        const response = await fetch(vaccinationsUrl);

        if (!response.ok) {
            throw new Error('vaccinations.json konnte nicht geladen werden.');
        }

        const vaccinations = await response.json();

        vaccinationsCache = sortVaccinationsByName(vaccinations);

        return vaccinationsCache;
    } catch (ex) {
        console.error('Impfstoffe konnten nicht geladen werden.', ex.message, ex);

        showAlert(
            'Impfstoffe konnten nicht geladen werden. Bitte lade die Seite erneut.',
            'danger'
        );

        return [];
    }
}

function hasExistingVaccinationInput() {
    const existingRows = readExistingVaccinationRows();

    return existingRows.some((row) => {
        return row.vaccinationDate || row.vaccinationId || row.expirationDate;
    });
}

function validateAiImageFiles(imageFiles) {
    if (!imageFiles || imageFiles.length === 0) {
        return 'Bitte wähle zuerst ein oder mehrere Fotos deines Impfpasses aus.';
    }

    if (imageFiles.length > maxAiUploadFiles) {
        return 'Bitte lade maximal 4 Fotos gleichzeitig hoch.';
    }

    const totalSize = imageFiles.reduce((sum, imageFile) => {
        return sum + imageFile.size;
    }, 0);

    if (totalSize > maxAiUploadTotalBytes) {
        return 'Die Fotos sind zusammen zu groß. Bitte lade weniger oder kleinere Bilder hoch.';
    }

    for (const imageFile of imageFiles) {
        if (!allowedAiUploadTypes.includes(imageFile.type)) {
            return 'Bitte lade nur Fotos im Format JPG, PNG oder WEBP hoch.';
        }

        if (imageFile.size <= 0) {
            return 'Eine der ausgewählten Dateien ist leer.';
        }

        if (imageFile.size > maxAiUploadBytesPerFile) {
            return 'Ein Foto ist zu groß. Bitte nutze pro Bild maximal 6 MB.';
        }
    }

    return null;
}

async function readVaccinePassImage() {
    hideAlert();
    hideAiUploadStatus();

    if (!vaccinePassReaderUrl) {
        showAiUploadStatus(
            'Der automatische Auslesedienst ist noch nicht konfiguriert.',
            'danger'
        );

        return;
    }

    const imageInput = document.querySelector('#vaccinePassImage');

    if (!imageInput || !imageInput.files || imageInput.files.length === 0) {
        showAiUploadStatus(
            'Bitte wähle zuerst ein oder mehrere Fotos deines Impfpasses aus.',
            'warning'
        );

        return;
    }

    const imageFiles = Array.from(imageInput.files);
    const validationMessage = validateAiImageFiles(imageFiles);

    if (validationMessage) {
        showAiUploadStatus(
            validationMessage,
            'warning'
        );

        return;
    }

    if (hasExistingVaccinationInput()) {
        const userConfirmed = window.confirm(
            'Es sind bereits Impfungen eingetragen. Wenn du den Impfpass automatisch auslesen lässt, werden die aktuellen Tabellenwerte ersetzt. Fortfahren?'
        );

        if (!userConfirmed) {
            return;
        }
    }

    setAiUploadLoading(true);

    showAiUploadStatus(
        imageFiles.length === 1
            ? 'KI analysiert dein Impfpassfoto ...'
            : `KI analysiert ${imageFiles.length} Impfpassfotos ...`,
        'loading'
    );

    try {
        const formData = new FormData();

        imageFiles.forEach((imageFile) => {
            formData.append('vaccinePassImages[]', imageFile, imageFile.name);
        });

        const response = await fetch(
            vaccinePassReaderUrl,
            {
                method: 'POST',
                headers: {
                    'X-Impfguide-Client': aiClientHeaderValue
                },
                body: formData
            }
        );

        let responseJson = null;

        try {
            responseJson = await response.json();
        } catch (jsonError) {
            throw new Error(
                'Der Server hat keine gültige Antwort geliefert. Bitte versuche es später erneut.'
            );
        }

        if (!response.ok || !responseJson.success) {
            const serverMessage =
                responseJson?.error?.message ??
                'Der Impfpass konnte nicht automatisch ausgelesen werden.';

            throw new Error(serverMessage);
        }

        const extractedVaccinations =
            responseJson.data?.vaccinations ??
            responseJson.parsedResponse?.vaccinations ??
            [];

        if (!extractedVaccinations || extractedVaccinations.length === 0) {
            showAiUploadStatus(
                'Es konnten keine Impfungen erkannt werden. Bitte versuche es mit einem schärferen Foto erneut oder trage die Daten manuell ein.',
                'warning'
            );

            return;
        }

        const fillResult = await fillVaccinationTableFromAiResult(extractedVaccinations);

        if (fillResult.unmatched > 0 || fillResult.needsReview > 0) {
            const unmatchedInfo = fillResult.unmatchedNames.length > 0
                ? ` Nicht automatisch zugeordnet: ${fillResult.unmatchedNames.join(', ')}.`
                : '';

            showAiUploadStatus(
                `${fillResult.total} Impfung(en) erkannt. ${fillResult.matched} Impfstoff(e) konnten automatisch zugeordnet werden.${unmatchedInfo} Gelb markierte Felder bitte manuell prüfen.`,
                'warning'
            );
        } else {
            showAiUploadStatus(
                `${fillResult.total} Impfung(en) erkannt und eingetragen. Bitte prüfe alle Werte sorgfältig.`,
                'success'
            );
        }
    } catch (ex) {
        console.error(ex);

        showAiUploadStatus(
            ex.message || 'Der Impfpass konnte nicht automatisch ausgelesen werden. Bitte trage die Daten manuell ein.',
            'danger'
        );
    } finally {
        setAiUploadLoading(false);
    }
}

function normalizeExtractedVaccinations(extractedVaccinations) {
    const filteredVaccinations = extractedVaccinations.filter((vaccination) => {
        return vaccination.date ||
            vaccination.vaccineName ||
            vaccination.vaccinationName ||
            vaccination.expiryDate ||
            vaccination.expirationDate;
    });

    const seen = new Set();

    const deduplicatedVaccinations = filteredVaccinations.filter((vaccination) => {
        const vaccineName =
            vaccination.vaccineName ??
            vaccination.vaccinationName ??
            '';

        const expiryDate =
            vaccination.expiryDate ??
            vaccination.expirationDate ??
            '';

        const key = [
            vaccination.date ?? '',
            normalizeVaccinationName(vaccineName),
            expiryDate
        ].join('|');

        if (seen.has(key)) {
            return false;
        }

        seen.add(key);

        return true;
    });

    return deduplicatedVaccinations.sort((vaccinationA, vaccinationB) => {
        const dateA = vaccinationA.date;
        const dateB = vaccinationB.date;

        if (dateA === dateB) {
            return 0;
        }

        if (!dateA) {
            return 1;
        }

        if (!dateB) {
            return -1;
        }

        return dateA.localeCompare(dateB);
    });
}

async function fillVaccinationTableFromAiResult(extractedVaccinations) {
    const normalizedVaccinations = normalizeExtractedVaccinations(extractedVaccinations);

    await setVaccinationRows(normalizedVaccinations.length || 1);

    const vaccinationRows = Array.from(
        document.querySelectorAll('table.vaccinations tbody tr')
    );

    const vaccinations = await loadVacs();

    let matched = 0;
    let unmatched = 0;
    let needsReview = 0;
    const unmatchedNames = [];

    normalizedVaccinations.forEach((extractedVaccination, index) => {
        const row = vaccinationRows[index];

        if (!row) {
            return;
        }

        const vaccinationDateInput = row.querySelector(':scope input.vaccination-date');
        const vaccinationSelect = row.querySelector(':scope select.vaccination');
        const expirationDateInput = row.querySelector(':scope input.expiration-date');

        row
            .querySelectorAll('.bg-ai-needs-review')
            .forEach((element) => {
                element.classList.remove('bg-ai-needs-review');
            });

        const vaccineName =
            extractedVaccination.vaccineName ??
            extractedVaccination.vaccinationName ??
            '';

        const expiryDate =
            extractedVaccination.expiryDate ??
            extractedVaccination.expirationDate ??
            '';

        if (vaccinationDateInput && isValidIsoDate(extractedVaccination.date)) {
            vaccinationDateInput.value = extractedVaccination.date;
        } else if (vaccinationDateInput) {
            vaccinationDateInput.classList.add('bg-ai-needs-review');
            needsReview++;
        }

        if (expirationDateInput && isValidIsoDate(expiryDate)) {
            expirationDateInput.value = expiryDate;
        } else if (expirationDateInput && expiryDate) {
            expirationDateInput.classList.add('bg-ai-needs-review');
            needsReview++;
        }

        if (vaccinationSelect && vaccineName) {
            const matchingVaccination = findBestMatchingVaccination(
                vaccineName,
                vaccinations
            );

            if (matchingVaccination) {
                vaccinationSelect.value = matchingVaccination.id.toString();
                matched++;
            } else {
                vaccinationSelect.classList.add('bg-ai-needs-review');
                vaccinationSelect.title = `KI erkannte: ${vaccineName}`;
                unmatched++;
                needsReview++;

                if (!unmatchedNames.includes(vaccineName)) {
                    unmatchedNames.push(vaccineName);
                }
            }
        } else if (vaccinationSelect) {
            vaccinationSelect.classList.add('bg-ai-needs-review');
            unmatched++;
            needsReview++;
        }
    });

    document.querySelector('div.vaccinations-pass').style.display = 'block';

    return {
        total: normalizedVaccinations.length,
        matched,
        unmatched,
        needsReview,
        unmatchedNames: unmatchedNames.slice(0, 4)
    };
}

function findBestMatchingVaccination(detectedName, vaccinations) {
    const normalizedDetectedName = normalizeVaccinationName(detectedName);

    if (!normalizedDetectedName) {
        return null;
    }

    const aliasMatch = findVaccinationByAlias(normalizedDetectedName, vaccinations);

    if (aliasMatch) {
        return aliasMatch;
    }

    const exactMatch = vaccinations.find((vaccination) => {
        return normalizeVaccinationName(vaccination.name) === normalizedDetectedName;
    });

    if (exactMatch) {
        return exactMatch;
    }

    const containsMatch = vaccinations.find((vaccination) => {
        const normalizedVaccinationName = normalizeVaccinationName(vaccination.name);

        return normalizedDetectedName.includes(normalizedVaccinationName) ||
            normalizedVaccinationName.includes(normalizedDetectedName);
    });

    if (containsMatch) {
        return containsMatch;
    }

    const scoredMatches = vaccinations.map((vaccination) => {
        return {
            vaccination,
            score: calculateNameSimilarity(
                normalizedDetectedName,
                normalizeVaccinationName(vaccination.name)
            )
        };
    });

    scoredMatches.sort((matchA, matchB) => {
        return matchB.score - matchA.score;
    });

    if (scoredMatches[0]?.score >= 0.45) {
        return scoredMatches[0].vaccination;
    }

    return null;
}

function findVaccinationByAlias(normalizedDetectedName, vaccinations) {
    const aliases = [
        {
            contains: ['filavac'],
            target: 'Filavac VHD K C+V'
        },
        {
            contains: ['fila'],
            target: 'Filavac VHD K C+V'
        },
        {
            contains: ['rika vacc', 'duo'],
            target: 'Rikavacc Duo'
        },
        {
            contains: ['rikavacc', 'duo'],
            target: 'Rikavacc Duo'
        },
        {
            contains: ['rika vacc', 'myxo'],
            target: 'Rikavacc Myxo'
        },
        {
            contains: ['rikavacc', 'myxo'],
            target: 'Rikavacc Myxo'
        },
        {
            contains: ['rika', 'myxo'],
            target: 'Rikavacc Myxo'
        },
        {
            contains: ['myxo sc'],
            target: 'Rikavacc Myxo'
        },
        {
            contains: ['rika vacc', 'rhd'],
            target: 'Rikavacc RHD'
        },
        {
            contains: ['rikavacc', 'rhd'],
            target: 'Rikavacc RHD'
        },
        {
            contains: ['nobivac', 'myxo', 'rhd', 'plus'],
            target: 'Nobivac Myxo-RHD PLUS'
        },
        {
            contains: ['nobivac', 'plus', 'myxo', 'rhd'],
            target: 'Nobivac Plus Myxo RHD'
        },
        {
            contains: ['yurvac'],
            target: 'Yurvac'
        }
    ];

    const alias = aliases.find((aliasEntry) => {
        return aliasEntry.contains.every((part) => {
            return normalizedDetectedName.includes(part);
        });
    });

    if (!alias) {
        return null;
    }

    return vaccinations.find((vaccination) => {
        return normalizeVaccinationName(vaccination.name) === normalizeVaccinationName(alias.target);
    }) ?? null;
}

function normalizeVaccinationName(value) {
    if (!value) {
        return '';
    }

    return value
        .toString()
        .toLowerCase()
        .replace(/[+\-_/]/g, ' ')
        .replace(/[^a-z0-9äöüß ]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
}

function calculateNameSimilarity(valueA, valueB) {
    const tokensA = valueA.split(' ').filter(Boolean);
    const tokensB = valueB.split(' ').filter(Boolean);

    if (tokensA.length === 0 || tokensB.length === 0) {
        return 0;
    }

    const matchingTokens = tokensA.filter((tokenA) => {
        return tokensB.some((tokenB) => {
            return tokenA === tokenB ||
                tokenA.includes(tokenB) ||
                tokenB.includes(tokenA);
        });
    });

    return matchingTokens.length / Math.max(tokensA.length, tokensB.length);
}

async function startCheck() {
    hideAlert();

    const disclaimerCheckbox = document.querySelector('#disclaimerAccepted');
    const disclaimerContainer = document.querySelector('#disclaimerContainer');

    if (disclaimerContainer) {
        disclaimerContainer.classList.remove('bg-disclaimer--error');
    }

    if (!disclaimerCheckbox?.checked) {

        disclaimerContainer?.classList.add('bg-disclaimer--error');

        disclaimerContainer?.scrollIntoView({
            behavior: 'smooth',
            block: 'center'
        });

        showAlert(
            'Bitte bestätige zuerst den rechtlichen Hinweis.',
            'warning'
        );

        return;
    }

    const requiredElements = Array.from(
        document.querySelectorAll('.bg-vaccine-guide [required]')
    );

    const formIsValid = requiredElements.every((element) => {
        return element.reportValidity();
    });

    if (!formIsValid) {
        showAlert(
            'Bitte prüfe deine Eingaben.',
            'warning'
        );

        return;
    }

    const vaccinations = await loadVacs();

    if (!vaccinations || vaccinations.length === 0) {
        showAlert(
            'Es konnten keine Impfstoffe geladen werden. Bitte lade die Seite erneut.',
            'danger'
        );

        return;
    }

    const allKnown = document.querySelector('select.all-known').value;
    const hadMyxo = document.querySelector('select.had-myxomatosis').value;
    const vaccinationList = [];
    const tbody = document.querySelector('table.vaccinations tbody');

    tbody.querySelectorAll('tr').forEach((row) => {
        const selectedVaccinationId = row
            .querySelector(':scope select.vaccination')
            .value;

        const vaccinationFromData = vaccinations.find((vac) => {
            return vac.id.toString() === selectedVaccinationId;
        });

        if (!vaccinationFromData) {
            return;
        }

        const vaccinationDate = parseDateFromInput(
            row.querySelector(':scope input.vaccination-date').value
        );

        const expirationDateValue = row
            .querySelector(':scope input.expiration-date')
            .value;

        const expirationDate = parseDateFromInput(expirationDateValue);

        const vaccination = Object.assign(
            structuredClone(vaccinationFromData),
            {
                date: vaccinationDate,
                useUntil: expirationDate ?? vaccinationDate
            }
        );

        vaccinationList.push(vaccination);
    });

    const result = checkVaccination(
        vaccinationList,
        allKnown === '1',
        hadMyxo === '1'
    );

    if (result?.error) {
        showAlert(
            `Die Prüfung konnte nicht abgeschlossen werden: ${result.errorMessage}`,
            'danger'
        );

        return;
    }

    const divResultText = document.querySelector('div.result-text');

    divResultText.innerHTML = '';
    divResultText.classList.toggle('danger', result?.overallResult < 0);
    divResultText.classList.toggle('warning', result?.overallResult > 0);

    const resultTBody = document.querySelector('table.result tbody');

    resultTBody.innerHTML = '';

    Object.keys(result.sicknesses).forEach((sickness) => {
        const validUntil = result.sicknesses[sickness];
        const valid = new Date() - validUntil <= 0;

        let nextVaccinationDate = validUntil;

        const tolerance =
            result.sicknessMeta?.[sickness]?.tolerance ?? 0;

        if (tolerance > 0) {
            nextVaccinationDate = subtractDays(
                validUntil,
                tolerance
            );
        }

        resultTBody.innerHTML += `
            <tr>
                <td><strong>${sickness}</strong></td>
                <td>
                    <span class="bg-status-badge ${valid ? 'bg-status-badge--success' : 'bg-status-badge--danger'}">
                        ${valid ? 'Geschützt' : 'Ungeschützt'}
                    </span>
                </td>
                <td>${valid ? nextVaccinationDate.toLocaleDateString() : `Sofort, mit einem dieser Impfstoffe:<br><ul>${
                    vaccinations.filter((vac) => {
                        return vac.available && vac.protectionDuration[sickness]?.native;
                    })
                    .map((vac) => {
                        return `<li>${vac.name}</li>`;
                    })
                    .join('\r\n')
                }</ul>`}</td>
            </tr>
        `;
    });

    const resultHistoryElement = document.querySelector('div.result-history');

    resultHistoryElement.innerHTML = '';

    [...result.vaccinations].reverse().forEach((vaccination) => {
        resultHistoryElement.innerHTML += `
            <div class="bg-history-item">
                <div class="bg-history-title">
                    <span>${vaccination.name}</span>
                    <small>geimpft am ${vaccination.date?.toLocaleDateString() ?? 'Unbekannt'}</small>
                </div>

                <div class="bg-table-wrap">
                    <table class="bg-table bg-table--compact">
                        <thead>
                            <tr>
                                <th>Seuche</th>
                                <th>Gültig bis</th>
                                <th>Anmerkung</th>
                            </tr>
                        </thead>

                        <tbody>
                            ${Object.keys(vaccination?.result ?? {}).map((sickness) => {
                                const vacResult = vaccination.result[sickness];

                                return `
                                    <tr>
                                        <td><strong>${sickness}</strong></td>
                                        <td>${vacResult.validUntil?.toLocaleDateString() ?? '-'}</td>
                                        <td>${reasonToText(vacResult.reason)}</td>
                                    </tr>
                                `;
                            }).join('\n')}
                        </tbody>
                    </table>
                </div>
            </div>
        `;
    });

    showAlert(
        'Die Prüfung wurde erfolgreich durchgeführt.',
        'success',
        false
    );

    document.querySelector('.bg-result-card')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
}

function checkVaccination(listVaccinations, historyKnown, hadMyxo) {
    const sicknesses = ['RHD', 'RHD2', 'MYXO'];

    const toVac = {
        MYXO: hadMyxo ? new Date(2099, 11, 31) : getStartDate(),
        RHD: getStartDate(),
        RHD2: getStartDate()
    };

    const result = {
        overallResult: -1,
        sicknesses: toVac,
        sicknessMeta: {},
        vaccinations: listVaccinations,
        suggestions: []
    };

    try {
        const sortedVacs = listVaccinations.sort((v1, v2) => {
            return v1.date - v2.date;
        });

        const hadNativeBefore = {};

        if (hadMyxo) {
            hadNativeBefore.MYXO = true;
        }

        for (const vaccination of sortedVacs) {
            if (listVaccinations?.length === 0) {
                continue;
            }

            for (const sickness of sicknesses) {
                if (!vaccination.result) {
                    vaccination.result = {};
                }

                if (!vaccination.result[sickness]) {
                    vaccination.result[sickness] = {};
                }

                if (!vaccination.protectionDuration[sickness]) {
                    vaccination.result[sickness].reason = 100;
                    continue;
                }

                if (vaccination.date > vaccination.useUntil) {
                    vaccination.result[sickness].reason = 103;
                    continue;
                }

                if (vaccination.protectionDuration[sickness].native) {
                    setVaccinated(
                        vaccination,
                        sickness,
                        toVac,
                        result
                    );

                    hadNativeBefore[sickness] = true;
                    vaccination.result[sickness].reason = 200;
                } else {
                    if (hadNativeBefore[sickness]) {
                        const validVaccination = toVac[sickness];

                        if (vaccination.date <= validVaccination) {
                            setVaccinated(
                                vaccination,
                                sickness,
                                toVac,
                                result
                            );

                            vaccination.result[sickness].reason = 201;
                        } else if (
                            historyKnown &&
                            vaccination.id === 1 &&
                            toVac.MYXO - getStartDate() === 0
                        ) {
                            setVaccinated(
                                vaccination,
                                sickness,
                                toVac,
                                result
                            );

                            vaccination.result[sickness].reason = 203;
                        } else {
                            vaccination.result[sickness].reason = 101;
                        }
                    } else if (historyKnown) {
                        setVaccinated(
                            vaccination,
                            sickness,
                            toVac,
                            result
                        );

                        vaccination.result[sickness].reason = 202;
                    } else {
                        vaccination.result[sickness].reason = 102;
                    }
                }
            }

            result.sicknesses = toVac;
            result.vaccinations = listVaccinations;
        }
    } catch (ex) {
        console.error(ex);

        result.error = true;
        result.errorMessage = ex.message;
    }

    return result;
}

function setVaccinated(vaccination, sickness, toVac, result) {
    const protectionDuration = vaccination.protectionDuration[sickness];

    const protectionDays =
        protectionDuration.duration +
        protectionDuration.tolerance;

    const vaccinationProtection = addDays(
        vaccination.date,
        protectionDays
    );

    if (vaccinationProtection > toVac[sickness]) {
        toVac[sickness] = vaccinationProtection;
        vaccination.result[sickness].validUntil = vaccinationProtection;

        result.sicknessMeta[sickness] = {
            tolerance: protectionDuration.tolerance ?? 0,
            vaccinationName: vaccination.name
        };
    }
}

function readExistingVaccinationRows() {
    const rows = Array.from(
        document.querySelectorAll('table.vaccinations tbody tr')
    );

    return rows.map((row) => {
        return {
            vaccinationDate: row.querySelector(':scope input.vaccination-date')?.value ?? '',
            vaccinationId: row.querySelector(':scope select.vaccination')?.value ?? '',
            expirationDate: row.querySelector(':scope input.expiration-date')?.value ?? ''
        };
    });
}

async function ensureDefaultVaccinationRow() {
    const existingRows = document.querySelectorAll('table.vaccinations tbody tr');

    if (existingRows.length === 0) {
        await setVaccinationRows(1);
    }
}

async function addVaccinationRow() {
    const existingRows = document.querySelectorAll('table.vaccinations tbody tr');

    await setVaccinationRows(existingRows.length + 1);
}

async function setVaccinationRows(rowCount) {
    hideAlert();

    const vaccinationsPassElement = document.querySelector('div.vaccinations-pass');
    const table = document.querySelector('table.vaccinations');
    const body = table.tBodies[0];

    const existingRows = readExistingVaccinationRows();
    const vaccinations = await loadVacs();

    if (!vaccinations || vaccinations.length === 0) {
        return;
    }

    const safeRowCount = Math.max(1, parseInt(rowCount, 10) || 1);

    vaccinationsPassElement.style.display = 'block';

    let html = '';

    for (let i = 0; i < safeRowCount; i++) {
        const existingRow = existingRows[i] ?? {
            vaccinationDate: '',
            vaccinationId: '',
            expirationDate: ''
        };

        html += createVaccinationRowHtml(
            existingRow,
            vaccinations
        );
    }

    body.innerHTML = html;
}

function createVaccinationRowHtml(existingRow, vaccinations) {
    return `
        <tr>
            <td>
                <button
                    type="button"
                    class="bg-delete-row-button"
                    onclick="deleteVaccinationRow(this)"
                    title="Impfung löschen"
                    aria-label="Impfung löschen">
                    🗑️
                </button>
            </td>

            <td>
                <input
                    type="date"
                    name="vaccinationDate"
                    class="bg-form-control vaccination-date"
                    value="${existingRow.vaccinationDate}"
                    required>
            </td>

            <td>
                <select
                    name="vaccination"
                    class="bg-form-control vaccination"
                    required>
                    <option disabled ${existingRow.vaccinationId ? '' : 'selected'} value>
                        Bitte wählen...
                    </option>

                    ${vaccinations.map((vaccination) => {
                        const selectedAttribute =
                            vaccination.id.toString() === existingRow.vaccinationId
                                ? 'selected'
                                : '';

                        return `
                            <option value="${vaccination.id}" ${selectedAttribute}>
                                ${vaccination.name}
                            </option>
                        `;
                    }).join('\n')}
                </select>
            </td>

            <td>
                <input
                    type="date"
                    name="expirationDate"
                    class="bg-form-control expiration-date"
                    value="${existingRow.expirationDate}">
            </td>
        </tr>
    `;
}

async function resetForm() {
    hideAlert();
    hideAiUploadStatus();

    const imageInput = document.querySelector('#vaccinePassImage');

    if (imageInput) {
        imageInput.value = '';
    }

    const selectedFilesElement = document.querySelector('.bg-ai-upload__selected-files');
    const dropzoneElement = document.querySelector('.bg-ai-upload__dropzone');

    if (selectedFilesElement) {
        selectedFilesElement.textContent = 'Noch keine Dateien ausgewählt';
    }

    if (dropzoneElement) {
        dropzoneElement.classList.remove('has-files');
    }

    document.querySelector('select.all-known').value = 0;
    document.querySelector('select.had-myxomatosis').value = 0;
    document.querySelector('table.vaccinations tbody').innerHTML = '';
    document.querySelector('table.result tbody').innerHTML = '';
    document.querySelector('div.result-history').innerHTML = '';
    document.querySelector('div.result-text').innerHTML = '';
    document.querySelector('div.result-text').classList.remove('danger', 'warning');

    await setVaccinationRows(1);
}

function deleteVaccinationRow(button) {
    const row = button.closest('tr');

    if (!row) {
        return;
    }

    row.remove();

    const remainingRows = document.querySelectorAll('table.vaccinations tbody tr').length;

    if (remainingRows === 0) {
        setVaccinationRows(1);
    }
}

function getStartDate() {
    return new Date(1900, 0, 1);
}

function reasonToText(reason) {
    switch (reason) {
        case 100:
            return 'Der Impfstoff schützt nicht gegen diese Seuche.';

        case 101:
            return 'Der Impfstoff schützt nicht, da er nicht nativ ist und kein gültiger Impfschutz zum Zeitpunkt der Impfung bestand.';

        case 102:
            return 'Der Impfstoff schützt nicht, da er nicht nativ ist und die Impfhistorie unbekannt ist.';

        case 103:
            return 'Der Impfstoff schützt nicht, da er bereits abgelaufen verimpft wurde.';

        case 200:
            return 'Dieser Impfstoff schützt, da er als nativer Impfstoff auch bei unbekannter Historie einen Impfschutz aufbaut.';

        case 201:
            return 'Dieser nicht native Impfstoff schützt, da er geimpft wurde als ein gültiger Impfschutz bestand.';

        case 202:
            return 'Dieser nicht native Impfstoff schützt, da keine unbekannten Impfungen vorhanden sind.';

        case 203:
            return 'Dieser nicht native Impfstoff schützt ausnahmsweise auch ohne validen bestehenden Impfschutz, da nie eine Impfung gegen Myxo stattfand.';

        default:
            return 'Unbekannte Begründung.';
    }
}